import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{attrs:{"row":""}},[_c(VCol,{staticClass:"s8 input-field no-margins"},[(!_vm.valid)?_c('div',[_vm._v(" This page is not valid for this site group ")]):_c('div',{attrs:{"align":"center"}},[_c('PortfolioManagerTable',{attrs:{"randomKey":_vm.randomKey}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }